<div [appStoryblok]="_editable()" class="position-relative">
  <youtube-player class="videoWrapper" [videoId]="videoId"></youtube-player>
  @if (!(cookiebot$|async)?.marketing) {
    <div class="cookie-error">
      <p><b i18n>Ups! Vi kan ikke vise dig denne video</b></p>
      <p i18n>For at se videoen skal du acceptere markedsførings-cookies.</p>
      <a href="javascript: Cookiebot.renew()" i18n>Ændre cookie settings</a>
    </div>
  }
</div>
